<template>
  <div id="app">
    <!-- 公共顶部栏：登录页不显示 -->
    <header v-if="showHeader" class="app-header">
      <div class="app-header-inner">
        <div class="app-brand">银行流水管理系统</div>
        <a-dropdown placement="bottomRight">
          <div class="user-menu-trigger">
            <a-avatar :src="avatarUrl" :size="32" />
            <span class="user-name">{{ nickname || username || '用户' }}</span>
            <a-icon type="down" />
          </div>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="changepwd">
              <a-icon type="lock" />
              修改密码
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="logout">
              <a-icon type="logout" />
              退出登录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </header>

    <main class="app-main">
      <router-view />
    </main>

    <!-- 修改密码弹窗 -->
    <change-password-modal
      :visible.sync="pwdModalVisible"
      @success="handlePwdChanged"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ChangePasswordModal from '@/components/ChangePasswordModal.vue'

export default {
  name: 'App',
  components: { ChangePasswordModal },
  data() {
    return {
      pwdModalVisible: false
    }
  },
  computed: {
    ...mapState('auth', ['userinfo']),
    // 登录页不显示顶部栏
    showHeader() {
      return this.$route.path !== '/login'
    },
    nickname() {
      return this.userinfo && this.userinfo.nickname
    },
    username() {
      return this.userinfo && this.userinfo.username
    },
    avatarUrl() {
      return (this.userinfo && this.userinfo.avatar) || ''
    }
  },
  async created() {
    // 应用启动：已登录则拉取用户信息（刷新后恢复 userinfo）
    if (this.$store.getters['auth/isLoggedIn']) {
      try {
        await this.fetchUserinfo()
      } catch (e) {
        // token 失效等，401 拦截器会处理跳转
      }
    }
  },
  methods: {
    ...mapActions('auth', ['fetchUserinfo', 'logout']),
    handleMenuClick({ key }) {
      if (key === 'changepwd') {
        this.pwdModalVisible = true
      } else if (key === 'logout') {
        this.confirmLogout()
      }
    },
    confirmLogout() {
      this.$confirm({
        title: '确认退出登录？',
        onOk: async () => {
          await this.logout()
          this.$router.push('/login')
        }
      })
    },
    // 改密成功：token 已失效，跳登录页重新登录
    handlePwdChanged() {
      this.pwdModalVisible = false
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: #f0f2f5;
}

/* 顶部栏 */
.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.app-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
}
.app-brand {
  font-size: 16px;
  font-weight: 600;
  color: #1d2b3a;
  letter-spacing: 0.5px;
}
.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}
.user-menu-trigger:hover {
  background: rgba(0, 0, 0, 0.04);
}
.user-name {
  font-size: 14px;
  color: #4a5a6e;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 主体内容区：占满全宽，不留外边距 */
.app-main {
  padding: 0;
}
</style>
